import ContactUs from "../components/ContactUs";
import BreakingBoundaries from "../components/Newsroom/BreakingBoundaries";
import InTheNews from "../components/Newsroom/InTheNews";
//import NewsCarausel from "../components/Newsroom/NewsCarausel";
import NewsroomLanding from "../components/Newsroom/NewsroomLanding";
import StayConnected from "../components/Newsroom/StayConnected";
import StayInLoop from "../components/StayInLoop";

export default function Newsroom(){
    return(
        <>
        <NewsroomLanding />
        <InTheNews />
        <StayConnected />
        <BreakingBoundaries />
        <ContactUs />
        <StayInLoop />
        </>
    )
}